export class DataSyncService {
  public static timeoutTextBlurSetNodeData = 300;
  public static timeoutNeedNodeDataUpdate = DataSyncService.timeoutTextBlurSetNodeData + 10;
}
